const ES = {
  INPUTTYPE: {
    input: {
      default: "Caja de texto (Standar)",
      email: "Email",
      scala: "Scala",
      barcode: "Código de Barras",
      phone: "Teléfono",
      textarea: "Area de texto",
      password: "Contraseña",
      flex: "Flexible",
      number: "Número",
      currency: "Moneda",
      slider: "Slider",
      ranking: "Ranking",
      ipv4: "IPV4",
      ipv6: "IPV6",
      domain: "Dominio",
      multiInput: "Lista de opciones",
      checktext: "Lista opciones tipo Check",
      QRReader: "Lectura de QR",
      QRGen: "Generador de QR"
    },
    file: {
      default: "Carga de archivo"
    },
    boolean: {
      standar: "Verdadero ó falso",
      switch: "Verdadero ó falso tipo switch"
    },
    signature: {
      sign: "Firma",
      photo: "Imagen de la firma",
      dialog: "Dialogo de opcion para la firma"
    },
    choice: {
      multi: "Opción múltiple",
      multiOther: "Opción múltiple (otro, cual?)",
      radio: "Selección única",
      radioOther: "Selección única (otro, cual?)"
    },
    date: {
      datetime: "Fecha y hora",
      calendar: "Fecha",
      time: "Hora",
      unixtime: "Duración de actividades ó eventos"
    },
    label: {
      label: "Etiqueta",
      link: "Link",
      paragraph: "Parráfo",
      section: "Sección",
      info: "Lista informativa",
      action: "Acciones"
    },
    photo: {
      camera: "Camara",
      gallery: "Galeria de fotos",
      "gallery/camera": "Galeria de fotos ó camara",
      url: "Imagen por url"
    },
    viewer: {
      web: "Web",
      document: "Documento"
    },
    geo: {
      google: "Google",
      servi: "Servinformación",
      location: "Localización (Coordenadas)"
    },
    map: {
      google: "Google",
      servi: "Servinformación"
    },
    video: {
      url: "Video por url"
    },
    subform: {
      standar: "Subformulario Standar"
    },
    datasource: {
      standar: "Origen de datos standar",
      database: "Data Base",
      select: "Selección"
    }
  },
  FORMS: {
    // input: 'Cajas de texto',
    input: "Input",
    file: "Archivo",
    date: "Fechas",
    signature: "Firma",
    geo: "Geo",
    choice: "Selección",
    boolean: "Sí ó No",
    label: "Etiqueta",
    link: "Link",
    paragraph: "Párrafo",
    video: "Video",
    photo: "Fotografía",
    map: "Mapa",
    number: "Numéricos",
    network: "Red",
    list: "Lista",
    qr: "QR",
    informative: "Informativo",
    viewer: "Ventana informativa",
    subform: "Subformulario",
    datasource: "Origen de datos",
    save: "Guardar",
    exit: "Volver",
    imagen_url: "Imagen por url",
    ranges: "Input rangos"
  },
  MODULE: {
    nameForm: "Nombre del formulario",
    group: "Grupo",
    version: "Versión",
    isForm: "Es un subformulario?",
    addPage: "Agregar página",
    pagination: "Páginación",
    totalQuestions: "preguntas total",
    page: "Página",
    btnAddQuestion: "Agregar pregunta",
    btnAddQuestionOteher: "Agregar otra pregunta",
    btnAddComponent: "Agregar componente",
    btnAddComponentOther: "Agregar otro componente",
    downloadJson: "Descargar json",
    saveForm: "Guardar formulario",
    cleanForm: "Limpiar Formulario",
    listForms: "Nuevo Formulario",
    openForm: "Abrir Formulario",

    //TRANSLATE CARD QUESTION
    label: "Etiqueta",
    placeHolderLabel: "Nombre de la pregunta",
    component: "Componente",
    class: "Clase",
    description: "Descripción de la ayuda",
    subtitleDescription: "Breve descripción para guiar al usuario sobre la pregunta.",
    required: "Requerido",
    btnAddDependency: "Agregar Dependencia",
    setting: "Configurar",
    Pregunta: "Pregunta",
    Componente: "Componente",

    //MESSAGES ALERTS
    emptyLabel: "La etiqueta no debe estar vacia y su cadena de carácteres debe ser mayor a 2.",
    emptyOption: "El componente debe tener al menos una opción.",
    requiredUrl: "Este componente requiere de un contenido o una url",
    requiredSubform: "Este componente requiere agregar un subformulario.",
    requiredFql: "Agregue la consulta sql ó fql.",
    requiredType: "Seleccione el tipo de acción.",
    requiredOriginData: "No existe origen de datos para este componente.",
    RequiredMainField: "Seleccione el campo principal de búsqueda.",
    requiredListData: "Este componente requiere agregar una lista de datos, ingrese al configurar.",
    requiredQuestionsToActions: "Seleccione las preguntas para realizar la acción",
    maxQuestionsToActions: "Debe seleccionar al menos dos preguntas para realizar la acción",
    maxQuestionMode: "La moda debe contener mínimo 3 preguntas.",
    requiredSelectMutipleToFlex: "El flex no tiene relación con alguna pregunta de selección múltiple.",
    smgModeSchema: "La propiedad 'questions' de actions Debe contener mínimo 3 elementos para la moda",
    smgTwoElements: "La propiedad 'questions' de actions debe contener mínimo 2 elementos",
    msgContainerElements: "No esta dentro de las operaciones disponibles.",
    "msgErrorIndex": "El indice de la question debe ser mayor a -1 (related->question)",
    "msgErrorContent": "Hay campos de configuración de algunos componentes por completar.",
    "msgErrorData": "Hay campos de configuración de algunos componentes por completar.",
    "msgErrorTypeRelated": "Falta la propiedad type en el componente.",
    "msgErrorInheritedSubform": "Faltan campos por completar. revise el formulario",

    //SETTING QUESTIONS
    inputText: "Ingrese el texto",
    hexaColor: "Color hexadecimal",
    minValue: "Valor mínimo",
    maxValue: "Valor maximo",
    addOtherOption: "Añadir otra opción",
    getDateYear: "Tomar dato desde el año:",
    toYear: "Hasta el año:",
    selectFormatDate: "Seleccione formato de hora:",
    settingDomains: "Configurar dominios?",
    acceptAllDomains: "Aceptar todos los dominios",
    settingDomains: "Configurar dominios aceptados",
    subtitleDomain: "Dominios aceptados (@gmail.com, @hotmail.com, etc) (Define el/los dominio(s) válidos aceptados.)",
    matchList: "Listado de coincidencias. (Valida que el dominio cumpla con las coincidencias.)",
    typeFile: "Tipo de archivo.",
    lengthFile: "Tamaño máximo del archivo:",
    extensionsFiles: "Que extensiones desea aceptar:",
    valueMaxRanking: "Valor máximo de la calificación (Valor entero).",
    titleScala: "Agregar opciones",
    typePassword: "Tipo de contraseña",
    sliderOrientation: "Orientación del slider.",
    sliderValueInitial: "Valor inical:",
    optionMinimas: "Opciones mínimas:",
    optionMaximas: "Opciones máximas:",
    addOptionsTolist: "Agregar opciones a la lista. (Opciones seleccionables.)",
    MultiDescription: "Descripción de la etiqueta",
    otherWitch: "Otro, Cual?",
    typeSelector: "Tipo de selector",
    valueDefaultSwitch: "Valor por defecto del Switch",
    SwitchDescription: "Descripción",
    selectTypePhone: "Seleccione el tipo de teléfono.",
    inputKey: "Ingrese la key del mapa:",
    typeGeo: "Tipo de georreferenciación",
    typeFont: "Tipo de fuente:",
    lengthFont: "Tamaño de fuente",
    textiewLabel: "Texto:",
    inputLink: "Ingrese el link",
    selectModeView: "Seleccione modo de visualización.",
    inputParagraph: "Ingrese el párrafo:",

    containe: "Contiene",
    dependencies: "Dependencies",

    listInfo: {
      whereisData: "De donde desea extraer los datos:",
      locale: "Local",
      fromDataOrigin: "Desde un origen de datos",
      title: "Agrege las opciones manualmente o desde un origen de datos con el boton ubicado en la parte inferior.",
      nameLabel: "Nombre para la etiqueta informativa",
      keyCode: "Clave de búsqueda",
      add: "Agregar"
    },
    video: {
      label: "Ingrese url del vídeo:",
      subtitle: "Verifique que el vídeo sea público en la web y que contenga protocolo https."
    },
    image: {
      label: "Url de la imagen:",
      subtitle: "La url debe ser HTTPS"
    },
    map: {
      labelView: "Ingrese url del mapa a visualizar:",
      subtitleView: "Ingrese url del mapa a visualizar",
      subtitleKey: "Necesaria para consumir los servicios de georeferenciación."
    },
    subforms: {
      labelSubform: "Seleccione el subformulario",
      maxAnswer: "Cantidad máxima de respuestas:",
      minAnswer: "Cantidad mínima de respuestas:"
    },

    originDabataseStandar: {
      typeMethod: "Seleccione el método:",
      // limit: "Límite de búsqueda",
      limit: "Total registros",
      btnOrigin: "Origen de datos",
      keyCode: "Clave origen de datos",
      fieldMainSearch: "Campo principal de búsqueda:"
    },

    originDataBase: {
      typeQuery: "Tipo de consulta:",
      typeAction: "Tipo de acción:",
      query: "Consulta",
      messagge: "Mensaje"
    },

    originSelect: {
      limit: "Límite de búsqueda",
      btnOrigin: "Origen de datos",
      typeQuery: "Tipo de consulta:",
      typeAction: "Tipo de acción:",
      query: "Consulta",
      messagge: "Mensaje"
    },

    File: {
      allExtensions: "Todas las extensiones",
      images: "Imágenes",
      documents: "Documentos",
      Compressed: "Archivos compresos"
    },
    geo: {
      geo: "Geocoder",
      assisted: "Asistido",
      reverse: "Inverso"
    },
    phone: {
      movil: "Telefonos móvil",
      fixed: "Telefonos fijos",
      movilFixed: "Fijos y móvil"
    },
    radio: {
      radio: "Radio",
      comoboBox: "Combo Box",
      unique: "Única para múltiple respuestas"
    },
    password: {
      alphanumerico: "Alphanumerico",
      string: "Cadena de carácteres",
      number: "Numérico"
    },
    time: {
      standar: "AM/PM",
      militar: "MILITAR"
    },
    fuentes: {
      bold: "Negrita",
      normal: "Normal",
      italic: "Itálica"
    },
    viewer: {
      embebido: "Embebido",
      popup: "Popup",
      labelInputWeb: "Ingrese url de una web:",
      labelInputDocument: "Ingrese url de un documento público pdf:",
      labelViewInformation: "Forma de visualizar la información externa.",
      labelOrientation: "Orientación del componente."
    },
    paragraph: {
      onlyParagraph: "Sólo párrafo",
      titleParagraph: "Título y Párrafo"
    },
    orientation: {
      default: "Por defecto",
      landscape: "Landscape",
      portrait: "Portrait"
    },
    View: {
      external: "Externo",
      popup: "Popup"
    },
    methodOrigin: {
      readWrite: "Lectura y edición",
      onlyRead: "Solo lectura"
    },
    actions: {
      on_trigger: 'Acción por botón',
      on_event: 'Acción por evento',
      on_depend: 'Acción por dependencia',
      add: 'Sumatoria',
      sub: 'Restas sucesivas',
      multiply: 'Multiplicar',
      divider: 'División',
      avg: 'Promedio',
      mode: 'Moda',
      median: 'Mediana',
      min: 'Mínima',
      max: 'Máxima',
      default: 'Sin formato',
      number: 'Formato numérico',
      currency: 'Formato de moneda',
      percent: 'Formato de porcentaje',
      selectQuestions: 'Seleccionar preguntas',
      actionMode: 'Modo de ejecución',
      typeAction: 'Tipo de acción',
      formatDisplay: 'Formato a mostrar',
      semicolon: 'Punto y coma',
      underscore: 'Guión bajo',
      pipe: 'Pipe',
      comma: 'Coma',
      dash: 'Guión medio',
      space: 'Espacio, uno solo espacio'
    }
  },
  MODALS: {
    actions: {
      listQuestions: 'Lista de preguntas',
      search: 'Buscar...',
      ToAccept: 'Aceptar',
      cancel: 'Cancelar'
    },
    originSelect: {
      title: "Seleccione la pregunta para la condición",
      searchPlaceHolder: "Busca por id ó descripción..."
    },
    originSelectTrigger: {
      title: "Origen de datos",
      total: "Total registros:",
      Preview: "Preview",
      all: "Todos"
    },
    originChoice: {
      messagge: "Cuantos registros desea visualizar en las opciones?",
      messagge2: "Ya tienes datos en el Origen manual. Que deseas hacer con la nueva información.?",
      add: "Agregar",
      Replace: "Reemplazar",
      accept: "Aceptar"
    },
    movePage: {
      title: "Mover pregunta",
      pages: "Páginas",
      page: "Página",
      positionQuestion: "Posición de la pregunta:",
      move: "Mover",
      toInit: "Al inicio",
      after: "Despues de",
      before: "Antes de",
      toFinal: "Al final"
    },
    listForms: {
      titleSelect: "Seleccione el formulario",
      titleClean: "Borrar formulario de la lista.",
      name: "Nombre",
      state: "Estado",
      date: "Fecha",
      create: "Nuevo",
      update: "Actualizando",
      messaggeAlert: "Posiblemente tenga cambios sin guardar.",
      confirmMessage: "¿Deseda borrar el formulario de la lista?",
      btnAccept: "Aceptar",
      btnCancel: "Cancelar"
    },
    listInformative: {
      title: "Origen de datos",
      selectOriginData: "Seleccione un origen de datos",
      totalRecords: "Total registros",
      selectField: "Seleccione dos campos:",
      btnPreview: "Preview",
      limitData: "Límite de datos",
      messagges1: "Seleccione el campo que se visualizara como la etiqueta informativa.?",
      messagges2: "Ya tienes datos en la lista informativa. Que deseas hacer con la nueva información.?",
      btnAdd: "Agregar",
      btnReplace: "Reemplazar"
    },
    flex: {
      title: "Configuración flex",
      selectQuestion: "Seleccione pregunta",
      selectOptions: "Seleccione opción",
      component: "Componente",
      btnAddQuestion: "Agregar pregunta",
      Id: "Id",
      description: "Descripción",
      typeComponent: "Tipo",
      delete: "Eliminar",
      maximumSize: "Longitud Máxima:",
      minimumSize: "Longitud mínima:"
    },
    dependencias: {
      title: "Crear dependencias",
      searchPlaceHolder: "Buscar pregunta...",
      tabQuestion: "Preguntas",
      tabDependencies: "Dependientes",
      standar: "Standard",
      compuesta: "Compuesta",
      typeRelated: "Tipo de relación?",
      message: "La cadena de carácteres ingresada sera la condición para que las preguntas hijas se visualicen.",
      btnCreateDependency: "Crear dependencia",
      all: "All"
    },
    modalDependencias: {
      dependence: "Dependencia",
      dependencyBuilder: "Generador de dependencias",
      standard: "Standard",
      composite: "Compuesta",
      textEquals: "(Text) Igual a",
      passEquals: "(Password) Igual a",
      emailEquals: "(Email) Igual a",
      sliderEquals: "(Slider) Igual a",
      rankingEquals: "(Ranking) Igual a",
      numberEquals: "(Número) Igual a",
      valueEquals: "(Valor) Igual a",
      uniqueValue: "(Valor único) Igual a",
      multiValues: "Valor(es) Igual a",
      codebarEquals: "(Código Barras) Igual a",
      emptyFull: "Vacio/lleno",
      remove: "Remover",
      add: "Agregar",
      show: "Mostrar",
      delete: "Eliminar",
      search: "Buscar..."
    }
  }
};

export default ES;
